var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { createGlobalStyle } from 'styled-components';
import { Route, Switch, Redirect } from 'react-router';
import Layout from 'components/shared/Layout';
import { MEDIA_QUERIES } from 'shared/style';
import Admin from './Admin';
export var LoggedContext = React.createContext(null);
var GlobalStyle = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .block-scroll {\n    overflow: hidden;\n  }\n\n  .pc-tablet {\n    ", " {\n      display: none;\n    }\n  }\n\n  .phone {\n    ", " {\n      display: none;\n    }\n  }\n"], ["\n  .block-scroll {\n    overflow: hidden;\n  }\n\n  .pc-tablet {\n    ", " {\n      display: none;\n    }\n  }\n\n  .phone {\n    ", " {\n      display: none;\n    }\n  }\n"])), MEDIA_QUERIES.PHONE, MEDIA_QUERIES.PC_TABLET);
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.setLogged = function (logged) {
            _this.setState(function (prevState) {
                return {
                    loggedContext: __assign({}, prevState.loggedContext, { logged: logged }),
                };
            });
        };
        _this.state = {
            loggedContext: {
                logged: false,
                setLogged: _this.setLogged,
            },
        };
        return _this;
    }
    App.prototype.componentDidMount = function () {
        if (localStorage.getItem('token')) {
            this.setLogged(true);
        }
    };
    App.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(GlobalStyle, null),
            React.createElement(LoggedContext.Provider, { value: this.state.loggedContext },
                React.createElement(Switch, null,
                    React.createElement(Redirect, { exact: true, path: "/", to: "/mohyun" }),
                    React.createElement(Route, { path: "/mohyun", render: function (props) { return React.createElement(Layout, __assign({}, props, { project: 'mohyun' })); } }),
                    React.createElement(Route, { path: "/admin", component: Admin })))));
    };
    return App;
}(React.Component));
export default App;
var templateObject_1;
